// extracted by mini-css-extract-plugin
export default {"container":"NewFeaturetag_container__V8xa0","tag":"NewFeaturetag_tag__COr5J"};